'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
    var theme = _ref.theme;
    return _react2.default.createElement(
        'footer',
        { role: 'contentinfo', className: theme.footer },
        _react2.default.createElement(
            'div',
            { className: theme.flexcontainer },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'dl',
                    { 'aria-label': 'Kontakt redakt\xF8rene' },
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Ansv. redakt\xF8r og adm. direkt\xF8r'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:Gard.Steiro@vg.no' },
                            'Gard Steiro'
                        )
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Nyhetsredakt\xF8r'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:Tora.Bakke.Handlykken@vg.no' },
                            'Tora Bakke H\xE5ndlykken'
                        )
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Utviklingsredakt\xF8r'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:Ola.Stenberg@vg.no' },
                            'Ola E. Stenberg'
                        )
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Featureredakt\xF8r'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:Jane.Throndsen@vg.no' },
                            'Jane Throndsen'
                        )
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Politisk redakt\xF8r'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:Hanne.Skartveit@vg.no' },
                            'Hanne Skartveit'
                        )
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: 'https://www.vg.no/rettelser/' },
                        'Logg over rettelser VG har gjort'
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'dl',
                    { 'aria-label': 'Tips oss' },
                    _react2.default.createElement(
                        'dt',
                        null,
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            'Tips oss! '
                        ),
                        'SMS / MMS til'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'tel:2200' },
                            '2200'
                        )
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Ring'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'tel:22000000' },
                            '22 00 00 00'
                        )
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'E-post til tusentipset'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:2200@vg.no' },
                            '2200@vg.no'
                        )
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: 'https://www.vg.no/om-vg/kontakt-oss' },
                        'Kontakt VG'
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: 'https://support.pluss.vg.no/hc/no' },
                        'Hjelp'
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: 'http://annonseweb.schibsted.no/en-no/brands/vg-380' },
                        'Annonseinfo'
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    'VG har ikke ansvar for innhold p\xE5 eksterne nettsider som det lenkes til. Kopiering av materiale fra VG for bruk annet sted er ikke tillatt uten avtale.'
                ),
                _react2.default.createElement(
                    'span',
                    { className: theme.terms },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'https://payment.schibsted.no/terms?client_id=4e70a7cee962dd83650f0000' },
                            'Brukervilk\xE5r'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: 'http://www.vg.no/informasjon/privacy/' },
                            'Personvernerkl\xE6ring og informasjonskapsler (cookies)'
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            'p',
            { className: theme.legal },
            _react2.default.createElement(
                'a',
                { href: 'https://www.vg.no/informasjon/copyright/' },
                '\xA9 2019 VG'
            )
        )
    );
};

Footer.propTypes = {
    theme: _propTypes2.default.shape({
        footer: _propTypes2.default.string,
        flexcontainer: _propTypes2.default.string,
        legal: _propTypes2.default.string
    }).isRequired
};

exports.default = Footer;
//# sourceMappingURL=Footer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/footer/lib/cjs/Footer.js
 ** module id = 729
 ** module chunks = 1
 **/